import React from "react";
import "./ContactInfo.css";

const ContactInfo = () => {
  return (
    <section id="contact" className="contact-info-section">
      <h2>Contact Us</h2>
      <p className="contact-line">
        📞 <strong>Phone:</strong> <a href="tel:+91 8099188688">+91 8099188688</a>
      </p>
      <p className="contact-line">
        ✉️ <strong>Primary Email:</strong> <a href="mailto:md@shieldonsecurity.com">md@shieldonsecurity.com</a>
      </p>
      <p className="contact-line">
      ✉️ <strong>Secondary Email:</strong> <a href="mailto:shieldonss16@gmail.com">shieldonss16@gmail.com</a>
      </p>
      <p className="thankyou">We’re here to protect what matters most to you.</p>
    </section>
  );
};

export default ContactInfo;
